import React, {Component} from 'react';
import Portal from './Portal';
import './PositionAligner.css';

/**
 * Allows an element to be injected into the DOM globally, but have its position be aligned against another
 * local element, even if scrolling, resizing, redrawing etc occur.
 */
class PositionAligner extends Component {
	constructor() {
		super();

		this.state = {
			left: 0,
			top: 0
		};

		this.updatePosition = () => {
			// Prefer the first most recent sibling that isnt also a placeholder, fallback to placeholder
			const positionTarget =
				this.placeholder.previousSibling &&
				this.placeholder.previousSibling.previousSibling &&
				this.placeholder.previousSibling.className === 'PositionAligner-placeholder'
					? this.placeholder.previousSibling.previousSibling
					: this.placeholder.previousSibling || this.placeholder;

			const rect = positionTarget.getBoundingClientRect();
			const sourceRect = this.source.getBoundingClientRect();

			const pageOffset = {x: window.pageXOffset, y: window.pageYOffset};
			const top = pageOffset.y + rect.top + rect.height;
			let left = this.props.center
				? Math.max(0, pageOffset.x + rect.left + rect.width / 2 - sourceRect.width / 2)
				: Math.max(0, pageOffset.x + rect.left);

			const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
			const xclipping = vw - (left + sourceRect.width);

			// Prevent overflow on x axis. 8px buffer
			if (xclipping < 0) {
				left += xclipping - 8;
			}

			if (top !== this.state.top || left !== this.state.left) {
				this.setState({left, top});
			}
		};

		this.onScroll = () => {
			window.requestAnimationFrame(this.updatePosition);
		};

		this.scrollIntoView = () => {
			setTimeout(() => {
				const target = this.props.scrollIntoViewElement
					? this.props.scrollIntoViewElement()
					: this.target;
				target &&
					target.scrollIntoView({
						behaviour: 'smooth',
						block: 'start',
						inline: 'nearest'
					});
			}, 500);
		};
	}

	componentDidMount() {
		this.updatePosition();
		if (this.props.shown && this.props.scrollIn) {
			this.scrollIntoView();
		}
		window.addEventListener('scroll', this.onScroll);
		this.intervalUpdate = setInterval(this.updatePosition, 1000);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.shown && !this.props.shown) {
			this.updatePosition();
			if (this.props.scrollIn) {
				this.scrollIntoView();
			}
		}
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.onScroll);
		clearInterval(this.intervalUpdate);
	}

	render() {
		const {className = 'PositionAligner-wrapper', shown = false} = this.props;
		const {left, top} = this.state;

		return (
			<div className="PositionAligner-placeholder" ref={el => (this.placeholder = el)}>
				<div className="PositionAligner-scrollTarget" ref={el => (this.target = el)} />
				<Portal className="PositionAligner-portal">
					<div
						className={className}
						style={{left, top, visibility: shown ? 'visible' : 'hidden'}}
						ref={el => (this.source = el)}>
						{this.props.children}
					</div>
				</Portal>
			</div>
		);
	}
}

export default PositionAligner;



// WEBPACK FOOTER //
// ./src/widgets/PositionAligner.js